export default import.meta.ROLLUP_FILE_URL_XkoF7BSSbncKX_yOJhf3Ow;